import { PatientIssueId } from "../../shared/schema/schema";
import { createQueryKeys } from "../../shared/utils/create-query-keys";

export const patientIssuesQueryKeys = createQueryKeys("patient_issues", {
  search: (params: Record<string, unknown>) => params,
  get: (id: PatientIssueId) => id,
  patientIssues: null,
});
